// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"941f0236","261":"941f0236","439":"d02577c1","791":"85b12d32","830":"4a7705a8","993":"78a82a55"}[chunkId] + ".chunk.css";
};